
import React from "react";
import VideoPlayer from "@/components/course/VideoPlayer";

interface VideoHeaderProps {
  videoUrl: string;
  className?: string;
  autoPlay?: boolean;
}

const VideoHeader: React.FC<VideoHeaderProps> = ({ 
  videoUrl, 
  className = "",
  autoPlay = false
}) => {
  return (
    <div className={`mb-10 rounded-lg overflow-hidden shadow-lg ${className}`}>
      <VideoPlayer 
        src={videoUrl} 
        autoPlay={autoPlay}
        className="aspect-video w-full"
      />
    </div>
  );
};

export default VideoHeader;
